import * as React from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { generateCode } from "@_common/generate-code";
import Header from "@components/common/Header";
import {
  VendorCheckpointCreateS3DirectUpload,
  VendorCheckpointGeneratedPresignedURL,
  VendorCheckpointGeneratedPresignedURLResponseAPI,
  VendorCheckpointUploadDocument,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import { FileUploader } from "react-drag-drop-files";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import { toast } from "react-toastify";

interface IBulkUploadProps {}

const BulkUpload: React.FunctionComponent<IBulkUploadProps> = (props) => {
  let navigate = useNavigate();
  let mainParams = useParams();
  const [uploadedDocuments, setuploadedDocuments] = React.useState<any>([]);

  // const handleUploadDocumnets = (e: any) => {
  //   let allFiles: any = [];
  //   Array.from(e.target.files).forEach(async (item: any) => {
  //     let key = `bulk-upload/${generateCode()}-${getValue(item, `name`, "")}`;
  //     let response = await VendorCheckpointGeneratedPresignedURL({
  //       key: key,
  //       image_name: getValue(item, `name`, ""),
  //       action: "putObject",
  //     });
  //     if (response) {
  //       let formData = new FormData();
  //       formData.append("file", item);
  //       let s3UploadResp =
  //         await VendorCheckpointGeneratedPresignedURLResponseAPI(
  //           getValue(response, `data.url`, ""),
  //           formData
  //         );
  //       if (s3UploadResp === 200) {
  //         uploadedDocuments.push({
  //           key: key,
  //           is_s3_direct_upload: true,
  //           name: getValue(item, `name`, ""),
  //           // size:getValue(item,`size`,''),
  //           // file_type: "image",
  //           extension: `.${getValue(item, `name`, "").split(".")[1]}`,
  //           mime_type: getValue(item, `type`, ""),
  //         });
  //       }
  //     }
  //     setuploadedDocuments([...uploadedDocuments]);
  //   });
  //   // callS3BucketAPI(uploadedDocuments);
  // };

  const [loading, setLoading] = React.useState(false);
  const callS3BucketAPI = async () => {
    try {
      setLoading(true);
      let resp = await VendorCheckpointCreateS3DirectUpload({
        s3_upload_data: uploadedDocuments,
      });
      if (resp) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        // let checkpoint_ids = urlSearchParams.getAll("vendor_checkpoint_ids");
        let date = mainParams.date.split("-");
        let documentIDs = getValue(resp, `data.document_ids`, []);
        let user = JSON.parse(getValue(localStorage, `user`, {}));
        let vendor_id = getValue(user, `vendor.id`, "");

        let payload = {
          // vendor_checkpoint_ids: checkpoint_ids,
          document_ids: documentIDs,
          month: parseInt(date[1]),
          year: parseInt(date[0]),
          location_id: mainParams.id,
          vendor_id: vendor_id,
        };
        let response = await VendorCheckpointUploadDocument(payload);
        if (response) {
          setLoading(false);
          toast.success("Uploaded successfully");
          navigate(
            `/checkpoint/details/${mainParams.id}/${mainParams.date}/${
              mainParams.code
            }/${getValue(mainParams, `listenable`, false)}/${getValue(
              mainParams,
              `audit_status`,
              ""
            )}/${getValue(mainParams, `score`, "")}`
          );
          // console.log(response, "---->final response");
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleRemoveUploadedFiles = (id: string, index: number) => {
    let filtered = uploadedDocuments.filter(
      (item: any, key: any) => index !== key
    );
    setuploadedDocuments(filtered);
  };

  const handleNavigate = () => {
    navigate(
      `/checkpoint/details/${mainParams.id}/${mainParams.date}/${
        mainParams.code
      }/${getValue(mainParams, `listenable`, false)}/${getValue(
        mainParams,
        `audit_status`,
        ""
      )}/${getValue(mainParams, `score`, "")}`
    );
  };

  //-------------------- DRAG AND DROP PORTION ------------------//
  const [uploadLoading, setUploadLoading] = React.useState(false);
  const handleChange = async (e: any) => {
    const files = Array.from(e);

    setUploadLoading(true);

    try {
      for (let index = 0; index < files.length; index++) {
        const item: any = files[index];

        const key = `bulk-upload/${index}-${generateCode()}-${getValue(
          item,
          `name`,
          ""
        )}`;

        try {
          const response = await VendorCheckpointGeneratedPresignedURL({
            key: key,
            image_name: getValue(item, `name`, ""),
            action: "putObject",
          });

          if (!response) continue;

          const formData = new FormData();
          formData.append("file", item);

          const s3UploadResp =
            await VendorCheckpointGeneratedPresignedURLResponseAPI(
              getValue(response, `data.url`, ""),
              formData
            );

          if (s3UploadResp === 200) {
            uploadedDocuments.push({
              key: key,
              is_s3_direct_upload: true,
              name: getValue(item, `name`, ""),
              extension: `.${getValue(item, `name`, "").split(".")[1]}`,
              mime_type: getValue(item, `type`, ""),
              url: getValue(response, `data.url`, ""),
            });
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      setuploadedDocuments([...uploadedDocuments]);
      setUploadLoading(false);
    }
  };

  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];

  return (
    <div>
      <Header />
      <div className="checkpoint-wrapper position-relative">
        <div className="uploaded-details-wrapper uploaded-details-wrapper--checkpoint">
          <div className="uploaded-details-wrapper__header-checkpoint d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center py-4 cursor-pointer">
              <a onClick={() => handleNavigate()}>
                <img src="/images/back-arrow.svg" className="img-fluid " />
              </a>
              <p className="uploaded-details-wrapper__date px-2">
                Bulk Uploads
              </p>
            </div>
            <div className="button-wrapper d-flex align-items-center gap">
              <button className="ascent-button ascent-button--primary ascent-button--checkpoint d-flex align-items-center">
                <img src="/images/downloadicon.svg" className="img-fluid" />
                Download File Names
              </button>
            </div>
          </div>
          <div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint ">
            <div className="attach-files-wrapper">
              {uploadLoading ? (
                <label className="input-file-label position-relative w-100 text-center cursor-pointer mb-4">
                  <input
                    // type={'file'}
                    // onChange={handleUploadDocumnets}
                    multiple
                    className="d-none"
                  />
                  <div className="custom-inputfile">
                    <img
                      src="/images/input-file.png"
                      className="img-fluid mb-2"
                      height={40}
                      width={40}
                    />
                    <p className="custom-inputfile__text">Please wait...</p>
                  </div>
                </label>
              ) : (
                <div className="input-file-label position-relative w-100 text-center cursor-pointer mb-4">
                  {/* <input
									type={"file"}
									onChange={handleUploadDocumnets}
									multiple
									className="d-none"
								/> */}
                  <div
                  // className="d-none"
                  >
                    <DragAndDropFileComponent
                      uploadFile={handleChange}
                      name="file"
                      types={fileTypes}
                      multiple
                      // className="d-none"
                      classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint">
            <div className="d-flex justify-content-between">
              <h4>
                {getValue(uploadedDocuments, `length`, 0)} Uploads Complete
              </h4>
              <button
                onClick={callS3BucketAPI}
                disabled={
                  loading || getValue(uploadedDocuments, `length`, 0) === 0
                }
                className="ascent-button ascent-button--primary ascent-button--checkpoint d-flex align-items-center"
              >
                {loading ? "Please Wait..." : "Submit to Assign"}
              </button>
            </div>
            <br />
            Click assign all to attach it to respective checkpoints
            automatically
            <br />
            <br />
            {getValue(uploadedDocuments, `length`, 0) > 0 ? (
              uploadedDocuments.map((item: object, key: number) => {
                return (
                  <div
                    key={key}
                    className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                  >
                    <p>{getValue(item, `name`, "")}</p>
                    <div>
                      <img
                        src="/images/close-black.svg"
                        className="img-fluid cursor-pointer"
                        onClick={() =>
                          handleRemoveUploadedFiles(
                            getValue(item, `id`, ""),
                            key
                          )
                        }
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-center mt-2"> No Data Found</p>
            )}
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUpload;
